export enum Permission {
  CreateFeatureGroups = "CreateFeatureGroups",
  CreateNotification = "CreateNotification",
  CreateSearchShare = "CreateSearchShare",
  CreateTag = "CreateTag",
  CreateTenantColors = "CreateTenantColors",
  CreateToneOfVoice = "CreateToneOfVoice",
  CreateWorkspaceOrgShared = "CreateWorkspaceOrgShared",
  DeleteTag = "DeleteTag",
  DeleteToneOfVoice = "DeleteToneOfVoice",
  DeleteWorkspaceDocumentsOwn = "DeleteWorkspaceDocumentsOwn",
  ReadAllUsersConversations = "ReadAllUsersConversations",
  ReadFeatureFlag = "ReadFeatureFlag",
  ReadInsights = "ReadInsights",
  ReadRoles = "ReadRoles",
  RebuildProjection = "RebuildProjection",
  UpdateDashboardLayout = "UpdateDashboardLayout",
  ReadGroups = "ReadGroups",
  UpdateFeatureGroups = "UpdateFeatureGroups",
  UpdatePromptsApproval = "UpdatePromptsApproval",
  UpdateTag = "UpdateTag",
  UpdateTenantColors = "UpdateTenantColors",
  UpdateToneOfVoice = "UpdateToneOfVoice",
  UpdateUserFeatureFlag = "UpdateUserFeatureFlag",
  UpdateUserRoles = "UpdateUserRoles",
  UpdateWorkspaceSharingOrgShared = "UpdateWorkspaceSharingOrgShared",
  UpdateTenantMetadata = "UpdateTenantMetadata",
  ReadOrganizationInvitation = "ReadOrganizationInvitation",
  ReadOrganizationConnection = "ReadOrganizationConnection",
  CreateOrganizationInvitation = "CreateOrganizationInvitation",
  DeleteOrganizationInvitation = "DeleteOrganizationInvitation",
  UpdateSynonymGroup = "UpdateSynonymGroup",
  CreateHubspotTicket = "CreateHubspotTicket",
  DeleteUser = "DeleteUser",
  ManageOrphanedWorkspaces = "ManageOrphanedWorkspaces",
  ManageWidgetTemplates = "ManageWidgetTemplates",
  CreateConsolidationFeedback = "CreateConsolidationFeedback",
  ManagePiiSettings = "ManagePiiSettings",
  DeleteAnyConversation = "DeleteAnyConversation",
  ManageConsolidationPriority = "ManageConsolidationPriority",
}
